/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const intentPageMessages = defineMessages({
    intentPageTitle: {
        id: 'luis.intentPage.intentPageTitle',
        defaultMessage: 'LUIS: Intent Page: { intent }'
    },
    renameIntentToastStart: {
        id: 'luis.intentPage.renameIntentToastStart',
        defaultMessage: 'Renaming intent ...'
    },
    renameIntentToastSuccess: {
        id: 'luis.intentPage.renameIntentToastSuccess',
        defaultMessage: 'Rename intent completed'
    },
    renameIntentToastFailed: {
        id: 'luis.intentPage.renameIntentToastFailed',
        defaultMessage: 'Rename intent failed'
    },
    filtersApplied: {
        id: 'luis.intentPage.filtersApplied',
        defaultMessage: 'Filters applied:'
    },
    editUtteranceAccessibilityConfirmation: {
        id: 'luis.intentPage.editUtteranceAccessibilityConfirmation',
        defaultMessage: 'Successfully modified utterance'
    },
    reassignUtteranceAccessibilityConfirmation: {
        id: 'luis.intentPage.reassignUtteranceAccessibilityConfirmation',
        defaultMessage: 'Successfully reassigned utterance'
    },
    examplesTitle: {
        id: 'luis.intentPage.examplesTitle',
        defaultMessage: 'Examples'
    },
    examplesDescription: {
        id: 'luis.intentPage.examplesDescription',
        defaultMessage: 'Examples are input from the user that your app needs to interpret'
    }
});
